import {Routes} from '@angular/router';
import {DashboardComponent} from './pages/dashboard/dashboard.component';
import {FormsComponent} from './pages/forms/forms.component';
import {ProcessesComponent} from './pages/processes/processes.component';
import {SettingsComponent} from './pages/settings/settings.component';
import {UsersComponent} from './pages/users/users.component';
import {EbicsComponent} from './pages/ebics/ebics.component';
import {MonitoringComponent} from './pages/monitoring/monitoring.component';
import {LoginFormEditorComponent} from './pages/login-form-editor/login-form-editor.component';
import {TranslationsComponent} from './pages/translations/translations.component';
import {SwissQrCodeComponent} from './pages/swiss-qr-code/swiss-qr-code.component';
import {ProcessEditorComponent} from './pages/process-editor/process-editor.component';
import {unsavedChangesGuard} from './guards/unsaved-changes.guard';

export const routes: Routes = [
  {path: '', component: DashboardComponent},
  {path: 'forms', component: FormsComponent},
  {path: 'forms/:id', component: FormsComponent, canDeactivate: [unsavedChangesGuard]},
  {path: 'processes', component: ProcessesComponent},
  {path: 'processes/:processDefinitionId/edit', component: ProcessEditorComponent, canDeactivate: [unsavedChangesGuard]},
  {path: 'processes/:processDefinitionId/translations', component: TranslationsComponent},
  {path: 'translations', component: TranslationsComponent},
  {path: 'swiss-qr-code', component: SwissQrCodeComponent},
  {path: 'login-form', component: LoginFormEditorComponent},
  {path: 'ebics', component: EbicsComponent},
  {path: 'settings', component: SettingsComponent},
  {path: 'users', component: UsersComponent},
  {path: 'monitoring', component: MonitoringComponent},
  {path: '**', redirectTo: ''}
];
